import Vue from "vue"; 
import Router from "vue-router";

// Public Login Anima
const login_page = () => import("../login/LoginPage");
// Containers
const default_container = () => import("@/containers/DefaultContainer");
// Views
const dashboard = () => import("@/views/Dashboard");
// Views - Pages
const page_403 = () => import("@/views/pages/Page403");
const page_noCapabilities = () => import("@/views/pages/PageNoCapabilites");
const page_404 = () => import("@/views/pages/Page404");
const page_500 = () => import("@/views/pages/Page500");
const unsubscribe = () => import("@/views/pages/unsubscribe");

// Products
const product_list = () => import("@/views/products/Product_list");
const product_view = () => import("@/views/products/Product_view");
const product_edit = () => import("@/views/products/Product_edit");


// Users
const users = () => import("@/views/settings/Users");
// User (New/Edit)
const user = () => import("@/views/settings/User");
//Connections
const companies = () => import("@/views/settings/Companies");
// User (New/Edit)
const company = () => import("@/views/settings/Company");
//SalesAgents by Tuta
const salesAgents = () => import("@/views/settings/SalesAgents");
// SalesAgent by Tuta
const salesAgent = () => import("@/views/settings/SalesAgent");
// Groups
const groups = () => import("@/views/settings/Groups");
// Group (New/Edit)
const group = () => import("@/views/settings/Group");
// Group GroupCapabilities (New/Edit)
const group_capabilities = () => import("@/views/settings/GroupCapabilities");
// Group GroupRoles
const roles = () => import("@/views/settings/Roles");
// Group GroupRolesCapabilities (New/Edit)
const role_capabilities = () => import("@/views/settings/RoleCapabilities");

// Roles
//const Roles = () => import ('@/views/settings/Roles');
// Group (New/Edit)
const role = () => import("@/views/settings/Role");

//General settings
const general_settings = () => import("@/views/settings/GeneralSettings");

// Wallets
const wallets_list = () => import("@/views/wallets/List");
const wallet_new = () => import("@/views/wallets/New");

// Wallet Segments
const walletSegments_list = () => import("@/views/wallet-segments/List");
const walletSegments_new = () => import("@/views/wallet-segments/New");

// QR codes
const qr_maker = () => import("@/views/qrCodes/QrMaker");
const qrcodes = () => import("@/views/qrCodes/QrCodes");

// NFC Chips by Tuta
const nfcChips = () => import("@/views/qrCodes/NfcChips");

// Media Library
const media_list = () => import("@/views/media-library/List");
const media_new = () => import("@/views/media-library/New");
const media_view = () => import("@/views/media-library/View");

// Campaign
const campaign_list = () => import("@/views/campaigns/List");
const campaign_edit = () => import("@/views/campaigns/Edit");
const campaign_view = () => import("@/views/campaigns/View");

const campaign_builder = () => import("@/views/campaigns/builder/Builder");

// Leads (New/Edit)
const lead = () => import("@/views/connections/lead");
const lead_list = () => import("@/views/connections/lead_list");
const lead_view = () => import("@/views/connections/lead_view");
// frontend form builder
const formbuilder_new = () => import("@/views/form-builder/New");
const formbuilder_list = () => import("@/views/form-builder/List");
const formbuilder_display = () => import("@/views/form-builder/Display");
const formbuilder_result = () => import("@/views/form-builder/Results");
const formbuilder_history = () => import("@/views/form-builder/History");

const scan_constructor = () => import("@/views/scan/constructor");
// Object Segments
const customFields_list = () => import("@/views/custom-fields/List");
const customFields_new = () => import("@/views/custom-fields/New");


// Analytics
const analytic_list = () => import("@/views/analytics/analytic_list");
const analytic_view = () => import("@/views/analytics/analytic_view");
const analytic = () => import("@/views/analytics/analytic");

//Graph
const graph_list = () => import("@/views/graph/graph_list");
const graph_view = () => import("@/views/graph/graph_view");
const graph = () => import("@/views/graph/graph");

// Financial Reports
const financial_list = () => import("@/views/financial-reports/financial_list");
const financial_view = () => import("@/views/financial-reports/financial_view");
const financial = () => import("@/views/financial-reports/financial");

// landing pages
const landingPage_list = () => import("@/views/landing-pages/List");
const landingPage_edit = () => import("@/views/landing-pages/Edit");
const landingPage_view = () => import("@/views/landing-pages/View");

const landingPage_builder = () => import("@/views/landing-pages/HtmlBuilder");

// Emails Templates
const emailTemplates_list = () => import("@/views/settings/EmailTemplates");
const emailTemplates_new = () => import("@/views/settings/EmailTemplate");

Vue.use(Router);

export const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/login",
      component: login_page,
      meta: {
        title: "Login",
        requiresAuth: false
      }
    },
    // scan Constructor
    {
      path: "/q/:companyId/:uniqueId",
      name: "scanConstructor",
      component: scan_constructor,
      meta: {
        title: "Scan",
        requiresAuth: false
      }
    },
    // Campaign Builder
    {
      path: "/campaign/:campaign_type/new/builder",
      name: "campaignNewBuilder",
      component: campaign_builder,
      meta: {
        title: "New Campaigns: Builder",
        requiresAuth: true
      }
    },
    {
      path: "/unsubscribe/:id/:username",
      component: unsubscribe,
      meta: {
        title: "Unsubscribe Successfully",
        requiresAuth: false
      }
    },
    // Not found
    {
      path: "*",
      name: "page_404",
      component: page_404,
      meta: {
        title: "Page not found",
        requiresAuth: true
      }
    },
    {
      path: "/no-permission",
      component: page_403,
      meta: {
        title: "Page not accessible",
        requiresAuth: false
      }
    },
    {
      path: "/no-permission-given",
      component: page_noCapabilities,
      meta: {
        title: "Page not accessible",
        requiresAuth: false
      }
    },
    {
      path: "/fb-display/:id",
      component: formbuilder_display,
      meta: {
        title: "Display form",
        requiresAuth: false
      }
    },
    {
      path: "/",
      redirect: "/dashboard",
      name: "home",
      component: default_container,
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          component: dashboard,
          meta: {
            title: "Dashboard",
            requiresAuth: true,
            permissionBaseName: "dashboard",
          }
        },
        {
          path: "connections",
          redirect: "/connections/companies",
          name: "connections",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "leads",
              name: "leads",
              component: lead_list,
              meta: {
                title: "leads",
                requiresAuth: true,
                permissionBaseName: "connectionLead",
              }
            },
            {
              path: "lead/view",
              name: "leadView",
              component: lead_view,
              meta: {
                title: "View Lead",
                requiresAuth: true,
                permissionBaseName: "connectionLead",
              }
            },
            {
              path: "lead/edit",
              name: "leadEdit",
              component: lead,
              meta: {
                title: "Edit Lead",
                requiresAuth: true,
                permissionBaseName: "connectionLead",
              }
            },
            {
              path: "lead/new",
              name: "leadCreate",
              component: lead,
              meta: {
                title: "Create Lead",
                requiresAuth: true,
                permissionBaseName: "connectionLead",
              }
            }
          ]
        },
        //products
        {
          path: "products",
          redirect: "/products",
          name: "product",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "/",
              name: "products",
              component: product_list,
              meta: {
                title: "Products",
                requiresAuth: true,
                permissionBaseName: "product",
              }
            },
            {
              path: "product/edit",
              name: "productEdit",
              component: product_edit,
              meta: {
                title: "Edit Product",
                requiresAuth: true,
                permissionBaseName: "product",
              }
            },
            {
              path: "/product/new",
              name: "productCreate",
              component: product_edit,
              meta: {
                title: "Create Product",
                requiresAuth: true,
                permissionBaseName: "product",
              }
            },
            {
              path: "/product/view",
              name: "productsView",
              component: product_view,
              meta: {
                title: "View Product",
                requiresAuth: true,
                permissionBaseName: "product",
              }
            }
          ]
        },
        //Analytics
    {
      path: "analytics",
          redirect: "/analytics",
          name: "analytic",
          component: {
            render(c) {
              return c("router-view");
            }
          },
      children: [
        {
          path: "/",
          name: "analytics",
          component: analytic_list,
          meta: {
            title: "Analytics",
            requiresAuth: true,
            permissionBaseName: "analytics",
          }
        },
        {
          path: "view",
          name: "analyticView",
          component: analytic_view,
          meta: {
            title: "View Analytic",
            requiresAuth: true,
            permissionBaseName: "analytics",
          }
        },
        {
          path: "edit",
          name: "analyticEdit",
          component: analytic,
          meta: {
            title: "Edit Analytic",
            requiresAuth: true,
            permissionBaseName: "analytics",
          }
        },
        {
          path: "new",
          name: "analyticCreate",
          component: analytic,
          meta: {
            title: "Create Analytic",
            requiresAuth: true,
            permissionBaseName: "analytics",
          }
        },
        {
          path: "graphs",
          name: "graphs",
          component: graph_list,
          meta: {
            title: "analytics",
            requiresAuth: true
          }
        },
        {
          path: "graph/view",
          name: "graphView",
          component: graph_view,
          meta: {
            title: "View Analytics",
            requiresAuth: true
          }
        },
        {
          path: "graph/edit",
          name: "graphEdit",
          component: graph,
          meta: {
            title: "Edit Analytics",
            requiresAuth: true
          }
        },
        {
          path: "graph/new",
          name: "graphCreate",
          component: graph,
          meta: {
            title: "Create Analytics",
            requiresAuth: true
          }
        }
      ]
    },{
      //Financial
      path: "financial",
          redirect: "/financial",
          name: "financial",
          component: {
            render(c) {
              return c("router-view");
            }
          },
      children: [
        {
          path: "/",
          name: "financials",
          component: financial_list,
          meta: {
            title: "Financial",
            requiresAuth: true,
            permissionBaseName: "financialReport",
          }
        },
        {
          path: "view",
          name: "financialView",
          component: financial_view,
          meta: {
            title: "View Financial",
            requiresAuth: true,
            permissionBaseName: "financialReport",
          }
        },
        {
          path: "edit",
          name: "financialEdit",
          component: financial,
          meta: {
            title: "Edit Financial",
            requiresAuth: true,
            permissionBaseName: "financialReport",
          }
        },
        {
          path: "new",
          name: "financialCreate",
          component: financial,
          meta: {
            title: "Create Financial",
            requiresAuth: true,
            permissionBaseName: "financialReport",
          }
        }
      ]
    },
        {
          path: "settings",
          redirect: "/settings/users",
          name: "settings",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            //Users
            {
              path: "users",
              name: "users",
              component: users,
              meta: {
                title: "Users",
                requiresAuth: true,
                permissionBaseName: "settingUser",
              }
            },
            {
              path: "user/edit/:id",
              name: "userEdit",
              component: user,
              meta: {
                title: "Edit User",
                requiresAuth: true,
                permissionBaseName: "settingUser",
              }
            },
            {
              path: "user/new",
              name: "userCrate",
              component: user,
              meta: {
                title: "Create User",
                requiresAuth: true,
                permissionBaseName: "settingUser",
              }
            },
            {
              path: "companies",
              name: "companies",
              component: companies,
              meta: {
                title: "Companies",
                requiresAuth: true,
                permissionBaseName: "settingCompany",
              }
            },
            {
              path: "company/edit",
              name: "companyEdit",
              component: company,
              meta: {
                title: "Edit Company",
                requiresAuth: true,
                permissionBaseName: "settingCompany",
              }
            },
            {
              path: "company/new",
              name: "companyCreate",
              component: company,
              meta: {
                title: "Create Company",
                requiresAuth: true,
                permissionBaseName: "settingCompany",
              }
            },
            {
              path: "company/users/:company",
              name: "companyUsers",
              component: users,
              meta: {
                title: "Company Users",
                requiresAuth: true,
                permissionBaseName: "settingCompany",
              }
            },
            {
              path: "salesAgents",
              name: "salesAgents",
              component: salesAgents,
              meta: {
                title: "Sales Agents",
                requiresAuth: true,
                permissionBaseName: "settingSaleAgent",
              }
            },
            //Groups
            {
              path: "groups",
              name: "groups",
              component: groups,
              meta: {
                title: "Groups",
                requiresAuth: true,
                permissionBaseName: "settingGroup",
              }
            },
            {
              path: "group/new",
              name: "groupCreate",
              component: group,
              meta: {
                title: "Create Group",
                requiresAuth: true,
                permissionBaseName: "settingGroup",
              }
            },
            {
              path: "group/edit",
              name: "groupEdit",
              component: group,
              meta: {
                title: "Edit Group",
                requiresAuth: true,
                permissionBaseName: "settingGroup",
              }
            },
            //capabalities for a group (id)
            {
              path: "group/capabilities",
              name: "groupCapabilities",
              component: group_capabilities,
              meta: {
                title: "Group Capabilities",
                requiresAuth: true,
                permissionBaseName: "settingGroup",
              }
            },
            //Roles
            {
              path: "group/roles", // list of roles for group (id)
              name: "groupRoles",
              component: roles,
              meta: {
                title: "Roles",
                requiresAuth: true,
                permissionBaseName: "settingRole",
              }
            },
            {
              path: "group/role/new", // create a new roel for group (id)
              name: "roleCreate",
              component: role,
              meta: {
                title: "Create Role",
                requiresAuth: true,
                permissionBaseName: "settingRole",
              }
            },
            {
              path: "role/edit",
              name: "roleEdit",
              component: role,
              meta: {
                title: "Edit Role",
                requiresAuth: true,
                permissionBaseName: "settingRole",
              }
            },
            {
              path: "roles", // list of roles for group (id)
              name: "roles",
              component: roles,
              meta: {
                title: "Roles",
                requiresAuth: true,
                permissionBaseName: "settingRole",
              }
            },
            //capabalities for a role (id)
            {
              path: "role/capabilities",
              name: "roleCapabilities",
              component: role_capabilities,
              meta: {
                title: "Role Capabilities",
                requiresAuth: true,
                permissionBaseName: "settingRole",
              }
            },
            {
              path: "email-templates",
              name: "email-Templates",
              component: emailTemplates_list,
              meta: {
                title: "Email Templates",
                requiresAuth: true,
                permissionBaseName: "settingEmailTemplate",
              }
            },
            {
              path: "email-templates/new",
              name: "email-Templates-new",
              component: emailTemplates_new,
              meta: {
                title: "Create New Email Templates",
                requiresAuth: true,
                permissionBaseName: "settingEmailTemplate",
              }
            },
            {
              path: "email-templates/edit/:id",
              name: "email-Templates-edit",
              component: emailTemplates_new,
              meta: {
                title: "Edit Email Templates",
                requiresAuth: true,
                permissionBaseName: "settingEmailTemplate",
              }
            },
            //General settings
            {
              path: "general-settings",
              name: "generalSettings",
              component: general_settings,
              meta: {
                title: "Configuration",
                requiresAuth: true,
                permissionBaseName: "settingGeneralSetting",
              }
            }
          ]
        },
        {
          path: "wallets",
          redirect: "/wallets/list",
          name: "wallet",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "/wallets/qr-maker",
              name: "qrcodeMaker",
              component: qr_maker,
              meta: {
                title: "QR Code Maker",
                requiresAuth: true,
                permissionBaseName: "walletQrMaker"
              }
            },
            {
              path: "/wallets/qrcodes",
              name: "qrcodes",
              component: qrcodes,
              meta: {
                title: "QR Code",
                requiresAuth: true,
                permissionBaseName: "walletQrCode",
              }
            },
            {
              //NFC Chips
              path: "/wallets/nfcChips",
              name: "nfcChips",
              component: nfcChips,
              meta: {
                title: "NFC Chips",
                requiresAuth: true,
                permissionBaseName: "walletNFCChip",
              }
            },
            {
              path: "/wallets/list",
              name: "wallets",
              component: wallets_list,
              meta: {
                title: "Wallet Listing",
                requiresAuth: true,
                permissionBaseName: "wallet",
              }
            },
            {
              path: "/wallets/new",
              name: "walletCreate",
              component: wallet_new,
              meta: {
                title: "Create Wallet",
                requiresAuth: true,
                permissionBaseName: "wallet",
              }
            },
            {
              path: "/wallets/edit",
              name: "walletEdit",
              component: wallet_new,
              meta: {
                title: "Edit Wallet",
                requiresAuth: true,
                permissionBaseName: "wallet",
              }
            }
          ]
        },
        {
          path: "wallet-segments",
          name: "wallet-segments",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "/wallet-segments/list",
              name: "walletSegments",
              component: walletSegments_list,
              meta: {
                title: "Wallet Segment",
                requiresAuth: true,
                permissionBaseName: "walletSegment",
              }
            },
            {
              path: "/wallet-segments/new",
              name: "walletSegmentCreate",
              component: walletSegments_new,
              meta: {
                title: "Create Wallet Segment",
                requiresAuth: true,
                permissionBaseName: "walletSegment",
              }
            },
            {
              path: "/wallet-segments/edit",
              name: "walletSegmentEdit",
              component: walletSegments_new,
              meta: {
                title: "Update Wallet Segment",
                requiresAuth: true,
                permissionBaseName: "walletSegment",
              }
            }
          ]
        },
        {
          path: "components",
          name: "components",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "/components/media",
              name: "media",
              component: media_list,
              meta: {
                title: "Media",
                requiresAuth: true,
                permissionBaseName: "componentMedia"
              }
            },
            {
              path: "/components/media/new",
              name: "mediaCreate",
              component: media_new,
              meta: {
                title: "Create Media",
                requiresAuth: true,
                permissionBaseName: "componentMedia"
              }
            },
            {
              path: "/components/media/edit",
              name: "mediaEdit",
              component: media_new,
              meta: {
                title: "Edit Media",
                requiresAuth: true,
                permissionBaseName: "componentMedia"
              }
            },
            {
              path: "/components/media/view/:id",
              name: "mediaView",
              component: media_view,
              meta: {
                title: "View Media",
                requiresAuth: true,
                permissionBaseName: "componentMedia"
              }
            },
            {
              path: "/components/form-builder",
              name: "formBuilder",
              component: formbuilder_list,
              meta: {
                title: "Custom Form",
                requiresAuth: true,
                permissionBaseName: "componentFormBuilder",
              }
            },
            {
              path: "/components/form-builder/new",
              name: "formBuilderCreate",
              component: formbuilder_new,
              meta: {
                title: "Create Custom Form",
                requiresAuth: true,
                permissionBaseName: "componentFormBuilder",
              }
            },
            {
              path: "/components/form-builder/edit/:id",
              name: "formBuilderEdit",
              component: formbuilder_new,
              meta: {
                title: "Edit Custom Form",
                requiresAuth: true,
                permissionBaseName: "componentFormBuilder",
              }
            },
            {
              path: "/components/form-builder/result/:id",
              name: "formBuilderResult",
              component: formbuilder_result,
              meta: {
                title: "Result Custom Form",
                requiresAuth: true,
                permissionBaseName: "componentFormBuilder",
              }
            },
            {
              path: "/components/form-builder/history/:id",
              name: "formBuilderHistory",
              component: formbuilder_history,
              meta: {
                title: "Change History",
                requiresAuth: true,
                permissionBaseName: "componentFormBuilder",
              }
            },
            {
              path: "/components/code-builder",
              name: "codeBuilder",
              component: formbuilder_list,
              meta: {
                title: "Code Form",
                requiresAuth: true,
                permissionBaseName: "componentFormCodeBuilder",
              }
            },
            {
              path: "/components/code-builder/new",
              name: "codeBuilderCreate",
              component: formbuilder_new,
              meta: {
                title: "Create Code Form",
                requiresAuth: true,
                permissionBaseName: "componentFormCodeBuilder",
              }
            },
            {
              path: "/components/code-builder/edit/:id",
              name: "codeBuilderEdit",
              component: formbuilder_new,
              meta: {
                title: "Edit Code Form",
                requiresAuth: true,
                permissionBaseName: "componentFormCodeBuilder",
              }
            },
            {
              path: "/components/code-builder/result/:id",
              name: "codeBuilderResult",
              component: formbuilder_result,
              meta: {
                title: "Result Code Form",
                requiresAuth: true,
                permissionBaseName: "componentFormCodeBuilder",
              }
            },
            {
              path: "/components/code-builder/history/:id",
              name: "codeBuilderHistory",
              component: formbuilder_history,
              meta: {
                title: "Change History",
                requiresAuth: true,
                permissionBaseName: "componentFormCodeBuilder",
              }
            },
            {
              path: "/components/image-builder",
              name: "imageBuilder",
              component: formbuilder_list,
              meta: {
                title: "Image Form",
                requiresAuth: true,
                permissionBaseName: "componentFormImageBuilder",
              }
            },
            {
              path: "/components/image-builder/new",
              name: "imageBuilderCreate",
              component: formbuilder_new,
              meta: {
                title: "Create Code Form",
                requiresAuth: true,
                permissionBaseName: "componentFormImageBuilder",
              }
            },
            {
              path: "/components/image-builder/edit/:id",
              name: "imageBuilderEdit",
              component: formbuilder_new,
              meta: {
                title: "Edit Code Form",
                requiresAuth: true,
                permissionBaseName: "componentFormImageBuilder",
              }
            },
            {
              path: "/components/image-builder/result/:id",
              name: "imageBuilderResult",
              component: formbuilder_result,
              meta: {
                title: "Result Code Form",
                requiresAuth: true,
                permissionBaseName: "componentFormImageBuilder",
              }
            },
            {
              path: "/components/image-builder/history/:id",
              name: "imageBuilderHistory",
              component: formbuilder_history,
              meta: {
                title: "Change History",
                requiresAuth: true,
                permissionBaseName: "componentFormImageBuilder",
              }
            },
            {
              path: "/components/custom-fields",
              name: "customFields",
              component: customFields_list,
              meta: {
                title: "Custom Fields",
                requiresAuth: true,
                permissionBaseName: "componentCustomField",
              }
            },
            {
              path: "/components/custom-fields/new",
              name: "customFieldCreate",
              component: customFields_new,
              meta: {
                title: "Create Custom Fields",
                requiresAuth: true,
                permissionBaseName: "componentCustomField",
              }
            },
            {
              path: "/components/custom-fields/edit/:id",
              name: "customFieldEdit",
              component: customFields_new,
              meta: {
                title: "Edit Custom Fields",
                requiresAuth: true,
                permissionBaseName: "componentCustomField",
              }
            },
            //Landing Pages
            {
              path: "/components/landing-pages",
              name: "landingPages",
              component: landingPage_list,
              meta: {
                title: "Landing-pages",
                requiresAuth: true,
                permissionBaseName: "componentLandingPage",
              }
            },
            {
              path: "/components/landing-pages/edit",
              name: "landingPageEdit",
              component: landingPage_edit,
              meta: {
                title: "Edit Landing-pages",
                requiresAuth: true,
                permissionBaseName: "componentLandingPage",
              }
            },
            {
              path: "/components/landing-pages/new",
              name: "landingPageCreate",
              component: landingPage_edit,
              meta: {
                title: "Create Landing-pages",
                requiresAuth: true,
                permissionBaseName: "componentLandingPage",
              }
            },    
          ]
        },
        {
          path: "campaigns",
          redirect: "/campaigns/authentication",
          name: "campaign",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "/campaigns/:campaign_type/list",
              name: "campaigns",
              component: campaign_list,
              meta: {
                title: "Campaigns Listing",
                requiresAuth: true,
                permissionBaseName: "campaign",
              }
            },
            {
              path: "/campaign/:campaign_type/new",
              name: "campaignCreate",
              component: campaign_edit,
              meta: {
                title: "New Campaigns",
                requiresAuth: true,
                permissionBaseName: "campaign",
              }
            },
            {
              path: "/campaign/:campaign_type/edit",
              name: "campaignEdit",
              component: campaign_edit,
              meta: {
                title: "Edit Campaigns",
                requiresAuth: true,
                permissionBaseName: "campaign",
              }
            },
            {
              path: "/campaign/:campaign_type/view",
              name: "campaignView",
              component: campaign_view,
              meta: {
                title: "View Campaigns",
                requiresAuth: true,
                permissionBaseName: "campaign",
              }
            }
          ]
        }
      ]
    }  
  ]
});

router.beforeEach((to, from, next) => {
  let redirectURLForQR = generateRedirectURLForQR(to);
  if (to.matched.some(record => record.meta.requiresAuth) && redirectURLForQR===null) {
    const loginUserInfo = localStorage.getItem('loginUserInfo') ? JSON.parse(localStorage.getItem('loginUserInfo'))  : null;
    if (!loginUserInfo) {
      return next("/login");
    }
    else{
      const loginCapabilities = loginUserInfo.db.userPermissionsBasedOnEntity;
      if(!loginCapabilities){
        const noCapabilitiesMsg = `No permission loaded, you can try login again.`
        alert(noCapabilitiesMsg);
        return next("/login");
      }
    }
  }
  /* Add browser title */
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  if (nearestWithTitle){
    document.title = nearestWithTitle.meta.title + " | YPB Systems";
  }
  if(redirectURLForQR !== null){
    next(redirectURLForQR);
  } else{
    next();
  }
});
const generateRedirectURLForQR = (to) => {
  const NATUREONEDIARY_TECH = { companyNumber: 2, hostname: 'natureonediary.tech'};
  const YPBCONNECT = { companyNumber: 1, hostname: 'ypbconnect.com'};
  if(to.name==='page_404'){
    let uniqueId = to.path.replace('/', '');
    if(uniqueId.length === 10){
      // can only consider this is the QR just only based on the length
      const hostName = location.hostname.replace('www.', '');
      let companyNumber = YPBCONNECT.companyNumber;
      if(hostName.includes(NATUREONEDIARY_TECH.hostname)){
        companyNumber = NATUREONEDIARY_TECH.companyNumber;
      }
      return `/q/${companyNumber}/${uniqueId}`;
    }
  }
  return null;
} 
